<script>
import appConfig from "@/app.config";
import Multiselect from "vue-multiselect";
import { http } from "../../../helpers/easyindustriaapi/config";
import axios from "axios";
import CnpjInput from '@/components/cnpj-input';

export default {
  page: {
    title: "Inserir Empresa",
    meta: [{ name: "description", content: appConfig.description }],
  },
  props: {
    currentEmpresa: {},
    oldEmpresa: { type: Object },
    ibge: { type: Array }, // não estou usand mais
  },
  components: {
    Multiselect,
    CnpjInput,
  },
  data() {
    return {
      legendCPFCNPJ: 'CNPJ',
      select_regime_trib: null,
      select_municipio: null,
      select_ambiente: null,
      select_emp_uf: null,
      razao: null,
      uf: null,
      editando: false,
      titleBody: "Inserindo Empresa",
      list2_cfop: ["one", "two", "tree"],
      tipos: [
        {
          id: 1,
          nome: "Producão",
        },
        {
          id: 2,
          nome: "Homologação",
        },
      ],
      regimes: [
        {
          id: 1,
          nome: "Simples Nacional",
        },
        {
          id: 2,
          nome: "Simples Nacional - excesso de sublimite da receita bruta",
        },
        {
          id: 3,
          nome: "Regime Normal",
        },
      ],
      estados: [],
      empresa: {
        cnpj: '',
        razao: '',
        apelido: '',
        fantasia: '',
        endereco: '',
        bairo: '',
        numero: '',
        complemento: '',
        fone: '',
        cep: '',
        ie: '',
        im: '',
        uf: '',
        cidade: '',
        pais_id: '',
        tokensefaz: '',
        idtokensefaz: '',
        crt: null,
        uhomprod: null,
        nfe_ind_sinc: false,
        manifesto_ultimo_nsu: '000000000000000',
        manifesto_filtro_emitente: 1,
      },
      cidadesIBGE: [],
      listPaises: [],
      paisDefault: {
        id: 1058, 
        nome: "Brasil", 
        created_at: null, 
        updated_at: null
      },
    };
  },
  created() {
    //this.empresa = this.oldEmpresa;
    this.$emit("newTitle", this.titleBody);
    // this.convert_citys();
    this.estados_ibge();
    
    // Garantir que empresa.cnpj seja sempre uma string
    if (!this.empresa.cnpj) {
      this.empresa.cnpj = '';
    }
  },
  mounted() {
    this.listPaises = [this.paisDefault];
    this.aplicarDadosEmpresaInicial();
  },
  methods: {
    aplicarDadosEmpresaInicial() {
      const origem = this.currentEmpresa && Object.keys(this.currentEmpresa).length
        ? this.currentEmpresa
        : this.oldEmpresa;

      if (!origem) {
        return;
      }

      const campos = [
        "nfe_ind_sinc",
        "manifesto_ultimo_nsu",
        "manifesto_filtro_emitente",
      ];

      campos.forEach((campo) => {
        if (Object.prototype.hasOwnProperty.call(origem, campo)) {
          this.$set(this.empresa, campo, Boolean(Number(origem[campo])));
        }
      });
    },
    setPost() {
      // Remover pontos e traços do CEP
      this.empresa.cep = this.empresa.cep.replace(/\D/g, '');
      this.$emit("doPost", {
        ...this.empresa,
        nfe_ind_sinc: Number(this.empresa.nfe_ind_sinc),
      });
    },
    seleciona_regime_trib(objeto) {
      this.empresa.crt = objeto.id;
    },
    async select_cidade_por_uf(objeto) {
      this.empresa.uf = objeto.sigla;
      this.empresa.uf_id = objeto.id;
      this.empresa.pais_id = "1058";
      
      // Buscar as cidades do IBGE para o estado selecionado
      try {
        await this.cidades_ibge(objeto);
      } catch (error) {
        console.error("erro ao carregar cidades:", error);
      }
    },
    // Função para normalizar texto removendo acentos e convertendo para minúsculas
    // Exemplo: "Ubatã" -> "ubata", "São Paulo" -> "sao paulo"
    normalizarTexto(texto) {
      if (!texto) return '';
      return texto
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '') // Remove acentos
        .toLowerCase()
        .trim();
    },
    // Função para calcular similaridade entre duas strings
    calcularSimilaridade(str1, str2) {
      if (!str1 || !str2) return 0;
      
      const s1 = this.normalizarTexto(str1);
      const s2 = this.normalizarTexto(str2);
      
      if (s1 === s2) return 1;
      
      // Caso especial: se uma string é versão sem acentos da outra
      if (s1.replace(/[^a-z0-9]/g, '') === s2.replace(/[^a-z0-9]/g, '')) {
        return 0.95; // Alta similaridade para casos como "UBATA" vs "Ubatã"
      }
      
      // Calcula similaridade baseada em caracteres em comum
      let matches = 0;
      const minLength = Math.min(s1.length, s2.length);
      
      for (let i = 0; i < minLength; i++) {
        if (s1[i] === s2[i]) matches++;
      }
      
      return matches / Math.max(s1.length, s2.length);
    },
    seleciona_cod_nome_municipio(event) {
      this.empresa.cidade = event.nome;
      this.empresa.cidade_id = event.id;
    },
    async cidades_ibge(objeto) {
      let uf = objeto.sigla;

      try {
        // bug , aqui , pois não da para pesquisar por emepresa_id
        // e  só consigo fazer o get por id ou estado ou nome ;
        let response = await http.get(
          `https://servicodados.ibge.gov.br/api/v1/localidades/estados/${uf}/municipios`
        );

        if (response.status === 200) {
          this.cidadesIBGE = response.data;
        }
      } catch (error) {
        console.error("erro ao buscar cidades:", error);
        let messageErro = error.response?.data;

        if (error.response) {
          switch (error.response.status) {
            case 406:
              this.makeToast(
                "danger",
                "Erro 406: " + (messageErro?.tipo
                  ? messageErro.tiponome
                  : messageErro?.tpag || "Erro desconhecido")
              );
              break;
            case 404:
              this.makeToast(
                "danger",
                "Erro 404: endpoint não encontrado ou servidor fora do ar"
              );
              break;
            default:
              this.makeToast("danger", error.message || "Erro desconhecido");
              break;
          }
        } else {
          this.makeToast("danger", "Erro de conexão: " + error.message);
        }
      }
    },
    seleciona_ambiente(event) {
      this.empresa.uhomprod = event.id;
    },
    makeToast(variant = null, message = "Error generic") {
      this.counter++;
      this.$bvToast.toast(message, {
        title: `Notificação`,
        toaster: "b-toaster-bottom-right",
        variant: variant,
        solid: true,
        appendToast: true,
      });
    },
    convert_citys() {
      this.ibge.forEach((cidade) => {
        this.adicionarSemDuplicatas(
          cidade.municipio.microrregiao.mesorregiao.UF
        );
      });
    },
    adicionarSemDuplicatas(novoObjeto) {
      if (!this.estados.some((objeto) => objeto.nome === novoObjeto.nome)) {
        this.estados.push(novoObjeto);
      }
    },
    setNewTitle() {
      this.$emit("newTitle", "Incluir Empresa " + this.empresa.id);
    },
    setPut() {
      // chamo a função de atualização do index;
      this.$emit("doPut", {
        ...this.empresa,
        nfe_ind_sinc: Number(this.empresa.nfe_ind_sinc),
      });
    },
    get_ibge() {},
    carregar_certificado() {
      // colocar o link do endpint aqui;
    },
    voltar() {
      this.$emit("back");
    },
    async estados_ibge() {
      try {
        // bug , aqui , pois não da para pesquisar por emepresa_id
        // e  só consigo fazer o get por id ou estado ou nome ;
        let response = await http.get(
          "https://servicodados.ibge.gov.br/api/v1/localidades/estados"
        );

        if (response.status === 200) {
          this.estados = response.data;
        }
      } catch (error) {
        console.error("erro ao carregar estados:", error);
        let messageErro = error.response?.data;

        if (error.response) {
          switch (error.response.status) {
            case 406:
              this.makeToast(
                "danger",
                "Erro 406: " + (messageErro?.tipo
                  ? messageErro.tiponome
                  : messageErro?.tpag || "Erro desconhecido")
              );
              break;
            case 404:
              this.makeToast(
                "danger",
                "Erro 404: endpoint não encontrado ou servidor fora do ar"
              );
              break;
            default:
              this.makeToast("danger", error.message || "Erro desconhecido");
              break;
          }
        } else {
          this.makeToast("danger", "Erro de conexão: " + error.message);
        }
      }
    },
    async search_new_cnpj(event) {
      console.log(event);
      try {
        let cnpj;
        if (typeof this.empresa.cnpj == "string") {
          if (
            this.empresa.cnpj.includes(".") &&
            this.empresa.cnpj.includes(".") &&
            this.empresa.cnpj.includes("/") &&
            this.empresa.cnpj.includes("-")
          ) {
            cnpj = this.empresa.cnpj
              .replace(".", "")
              .replace(".", "")
              .replace("/", "")
              .replace("-", "");
          } else {
            cnpj = this.empresa.cnpj;
          }
        }

        let response = await axios.get("https://api.cnpjs.dev/v1/" + cnpj);

        if (response.status === 200) {
          console.log(response.data);
          //let obj2 = response.data.data;
          // this.loader.get = false;
          setTimeout(() => {
            let obj = response.data;
            this.empresa.apelido = obj.nome_fantasia;
            this.empresa.razao = obj.razao_social;
            this.empresa.fantasia = obj.nome_fantasia; // obj.endereco.cep
            this.empresa.cep = obj.endereco.cep;
            this.empresa.numero = obj.endereco.numero;
            this.empresa.bairo = obj.endereco.bairro;
            this.empresa.complemento = obj.endereco.complemento;
            this.empresa.endereco =
              obj.endereco.tipo_logradouro + " " + obj.endereco.logradouro;
            this.empresa.fone = obj.telefone1;
            this.empresa.pais_id = "1058";
            this.empresa.uf = obj.endereco.uf;

            console.log(this.estados);
            let estado_obj = this.estados.find(
              (e) => e.sigla == obj.endereco.uf
            );
            //console.log(estado_obj)
            this.select_emp_uf = estado_obj;
            this.cidades_ibge(estado_obj);
          }, 1000);
          setTimeout(() => {
            console.log("mosrando cidades dentro do time func ");
            console.log(this.cidadesIBGE);
            let municipio = response.data.endereco.municipio;
            console.log(municipio);

            let cidadade_objeto = this.cidadesIBGE.find(
              (c) =>
                c.nome
                  .normalize("NFD")
                  .replace(/[\u0300-\u036f]/g, "")
                  .toUpperCase() ==
                municipio
                  .normalize("NFD")
                  .replace(/[\u0300-\u036f]/g, "")
                  .toUpperCase()
            );
            console.log("cidade objeto seleicionado");
            console.log(cidadade_objeto);
            this.select_municipio = cidadade_objeto;
            this.seleciona_cod_nome_municipio(cidadade_objeto);
          }, 1500);
        }
      } catch (error) {
        console.log(error);
        if (error.response && error.response.status === 403) {
          this.error("O Usuário não tem permissão!");
        }
      }
    },
    async setDataFromCnpj(data) {
      if (data) {
        this.empresa.razao = data.razao || '';
        this.empresa.apelido = data.fantasia || '';
        this.empresa.fantasia = data.fantasia || '';
        this.empresa.cep = data.cep || '';
        this.empresa.endereco = data.endereco || '';
        this.empresa.numero = data.numero || '';
        this.empresa.bairo = data.bairro || '';
        this.empresa.complemento = data.complemento || '';
            
        const selectedCountry = this.listPaises.find(pais => pais.nome === this.paisDefault.nome);
        if (selectedCountry) {
          this.empresa.pais_id = selectedCountry.id;
        }
        
        // Aguardar os estados serem carregados se necessário
        if (!this.estados || this.estados.length === 0) {
          await this.estados_ibge();
        }

        if (data.uf) {
          const selectedState = this.estados.find(obj => obj.sigla === data.uf);

          if (selectedState) {
            this.empresa.uf = selectedState.sigla;
            this.empresa.uf_id = selectedState.id;
            this.select_emp_uf = selectedState;
            
            // Aguardar as cidades serem carregadas antes de continuar
            await this.select_cidade_por_uf(selectedState);
            
            // Aguardar um pouco para garantir que as cidades foram carregadas
            await new Promise(resolve => setTimeout(resolve, 100));
          } else {
            console.log("selectedState não encontrado para UF:", data.uf);
          }
        }
        
        if (this.cidadesIBGE && this.cidadesIBGE.length > 0) {
          const cidadeNormalizada = this.normalizarTexto(data.cidade);
          
          // Busca usando texto normalizado (sem acentos)
          let selectedCity = this.cidadesIBGE.filter(city => {
            const cidadeIBGENormalizada = this.normalizarTexto(city.nome);
            return cidadeIBGENormalizada === cidadeNormalizada;
          });
          
          // Se não encontrar, tenta busca parcial com texto normalizado
          if (selectedCity.length === 0) {
            selectedCity = this.cidadesIBGE.filter(city => {
              const cidadeIBGENormalizada = this.normalizarTexto(city.nome);
              return cidadeIBGENormalizada.includes(cidadeNormalizada) ||
                     cidadeNormalizada.includes(cidadeIBGENormalizada);
            });
          }
          
          // Se ainda não encontrar, tenta busca mais flexível
          if (selectedCity.length === 0) {
            selectedCity = this.cidadesIBGE.filter(city => {
              const cidadeIBGENormalizada = this.normalizarTexto(city.nome);
              // Remove espaços e caracteres especiais para comparação mais flexível
              const cidadeLimpa = cidadeIBGENormalizada.replace(/[^a-z0-9]/g, '');
              const cidadeBuscaLimpa = cidadeNormalizada.replace(/[^a-z0-9]/g, '');
              return cidadeLimpa === cidadeBuscaLimpa;
            });
          }
          
          // Se ainda não encontrar, tenta busca por similaridade
          if (selectedCity.length === 0) {
            const cidadesComSimilaridade = this.cidadesIBGE.map(city => ({
              ...city,
              similaridade: this.calcularSimilaridade(city.nome, data.cidade)
            }))
            .filter(city => city.similaridade > 0.7) // Similaridade maior que 70%
            .sort((a, b) => b.similaridade - a.similaridade);
            
            if (cidadesComSimilaridade.length > 0) {
              selectedCity = [cidadesComSimilaridade[0]];
            }
          }
          
          if (selectedCity && selectedCity.length > 0) {
            this.empresa.cidade_id = selectedCity[0].id;
            this.empresa.cidade = selectedCity[0].nome;
            this.select_municipio = selectedCity[0];
          } else {
            // Mostra as cidades mais similares para debug
            const cidadesComSimilaridade = this.cidadesIBGE.map(city => ({
              nome: city.nome,
              normalizada: this.normalizarTexto(city.nome),
              similaridade: this.calcularSimilaridade(city.nome, data.cidade)
            }))
            .sort((a, b) => b.similaridade - a.similaridade)
            .slice(0, 5);
            console.log("cidades mais similares:", cidadesComSimilaridade);
          }
        } else {
          console.log("lista de cidades vazia ou não carregada");
        }
      }
    },
  },
};
</script>

<template>
  <div class="card">
    <div class="accordion" role="tablist">
      <form role="form" class="form-horizontal">
        <b-card no-body class="mb-1">
          <b-card-header header-tag="header" class="p-1" role="tab">
            <b-button block v-b-toggle.pedido-dados-gerais variant="light"
              >Informações da empresa</b-button
            >
          </b-card-header>
          <b-collapse
            id="pedido-dados-gerais"
            visible
            accordion="pedido-accordion"
            role="tabpanel"
          >
            <b-card-body>
              <div class="form-row form-group mb-3" role="group">
                <div class="col-md-4 col-sm-12">
                  <div class="form-group" id="espaco1">
                    <label for="cnpj_id" class="col-sm-2 col-form-label">CNPJ</label>
                    <CnpjInput :placeholder="legendCPFCNPJ" v-model="empresa.cnpj" @company-info="setDataFromCnpj" />
                  </div>
                </div>
              </div>
              <div class="form-row form-group" role="group">
                <div class="col-sm-12 col-md-4" id="desc_ID">
                  <div class="form-group">
                    <label for="nome_id" class="col-form-label">Apelido</label>
                    <div class="col">
                      <input
                        class="form-control text-left"
                        type="text"
                        placeholder="Digite um apelido para login"
                        id="nome_id"
                        v-model="empresa.apelido"
                      />
                    </div>
                  </div>
                </div>
                <div class="col-sm-12 col-md-4" id="desc_ID">
                  <div class="form-group">
                    <label for="empresa_fantasia" class="col-form-label">Nome fantasia</label>
                    <div class="col">
                      <input
                        class="form-control text-left"
                        type="text"
                        placeholder="Digite o nome fantasia da empresa"
                        id="empresa_fantasia"
                        v-model="empresa.fantasia"
                      />
                    </div>
                  </div>
                </div>
                <div class="col-sm-12 col-md-4">
                  <div class="form-group">
                    <label for="razao" class="col-form-label"
                      >Razão Social</label
                    >
                    <div class="col">
                      <input
                        v-model="empresa.razao"
                        class="form-control text-left"
                        type="text"
                        placeholder="Digite a razão social da empresa"
                        id="razao"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-row form-group" role="group" id="espaco">
                <div class="col-sm-6 col-md-3">
                  <div class="form-group">
                    <label for="endereco" class="col-form-label"
                      >Endereço
                    </label>
                    <div class="col">
                      <input
                        v-model="empresa.endereco"
                        class="form-control text-left"
                        placeholder="Digite o endereço"
                        id="endereco_id"
                      />
                    </div>
                  </div>
                </div>
                <div class="col-sm-6 col-md-3">
                  <div class="form-group">
                    <label for="bairro" class="col-form-label">Bairro</label>
                    <div class="col">
                      <input
                        v-model="empresa.bairo"
                        type="text"
                        class="form-control text-left"
                        placeholder="Digite o bairro"
                        id="bairro_id"
                      />
                    </div>
                  </div>
                </div>

                <div class="col-sm-6 col-md-3">
                  <div class="form-group">
                    <label for="numero" class="col-form-label">Número</label>
                    <div class="col">
                      <input
                        v-model="empresa.numero"
                        type="text"
                        class="form-control text-left"
                        placeholder="Digite o número"
                        id="numero_id"
                      />
                    </div>
                  </div>
                </div>
                <div class="col-sm-6 col-md-3">
                  <div class="form-group">
                    <label for="complemento" class="col-form-label"
                      >Complemento</label
                    >
                    <div class="col">
                      <input
                        v-model="empresa.complemento"
                        type="text"
                        class="form-control text-right"
                        placeholder="Digite o complemento"
                        id="complemento_id"
                      />
                    </div>
                  </div>
                </div>
                <div class="col-sm-6 col-md-4">
                  <div class="form-group">
                    <label for="telefone" class="col-form-label"
                      >Telefone</label
                    >
                    <div class="col">
                      <input
                        v-model="empresa.fone"
                        type="text"
                        class="form-control text-left"
                        placeholder="Digite o telefone"
                        id="telefone_id"
                      />
                    </div>
                  </div>
                </div>
                <div class="col-sm-6 col-md-4">
                  <div class="form-group">
                    <label for="cep" class="col-form-label">CEP</label>
                    <div class="col">
                      <input
                        v-model="empresa.cep"
                        type="text"
                        class="form-control text-left"
                        placeholder="Digite o CEP"
                        id="cep_id"
                      />
                    </div>
                  </div>
                </div>
                <div class="col-sm-6 col-md-4">
                  <div class="form-group">
                    <label for="insc_estadual" class="col-form-label"
                      >Inscrição Estadual</label
                    >
                    <div class="col">
                      <input
                        v-model="empresa.ie"
                        type="text"
                        class="form-control text-right"
                        placeholder="Digite a inscrição estadual"
                        id="insc_estadual_id"
                      />
                    </div>
                  </div>
                </div>
                <div class="col-sm-6 col-md-4">
                  <div class="form-group">
                    <label for="UF" class="col-form-label">UF</label>
                    <div class="col">
                      <Multiselect
                        v-model="select_emp_uf"
                        :options="estados"
                        label="nome"
                        @select="select_cidade_por_uf($event)"
                      >
                      </Multiselect>
                    </div>
                  </div>
                </div>
                <div class="col-sm-6 col-md-4">
                  <div class="form-group">
                    <label for="UF" class="col-form-label">Município</label>
                    <div class="col">
                      <multiselect
                        v-model="select_municipio"
                        :options="cidadesIBGE"
                        label="nome"
                        @select="seleciona_cod_nome_municipio($event)"
                      >
                      </multiselect>
                    </div>
                  </div>
                </div>

                <div class="col-sm-6 col-md-4">
                  <div class="form-group">
                    <label for="insc_municipal" class="col-form-label"
                      >Inscrição Municipal
                    </label>
                    <div class="col">
                      <input
                        v-model="empresa.im"
                        type="text"
                        class="form-control text-right"
                        placeholder="Digite a inscrição municipal"
                        id="insc_municipal_id"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </b-card-body>
          </b-collapse>
          <!-- Menus de Impostos-->

          <b-card-header header-tag="header" class="p-1" role="tab">
            <b-button block v-b-toggle.pedido-complementares variant="light"
              >Dados NFE</b-button
            >
          </b-card-header>
          <b-collapse id="pedido-complementares">
            <b-card-body>
              <div class="form-row form-group" role="group">
                <div class="col-sm-12 col-md-6">
                  <div class="form-group">
                    <label for="CSOSN" class="col-form-label"
                      >Chave de acesso</label
                    >
                    <div class="col">
                      <input
                        type="text"
                        class="form-control text-left"
                        id="CSOSN"
                      />
                    </div>
                  </div>
                </div>
                <div class="col-sm-12 col-md-6">
                  <div class="form-group">
                    <label for="Origem" class="col-form-label"
                      >Token Sefaz</label
                    >
                    <div class="col">
                      <input
                        type="text"
                        class="form-control text-left"
                        id="CSOSN"
                        v-model="empresa.tokensefaz"
                      />
                    </div>
                  </div>
                </div>
                <div class="col-sm-12 col-md-6">
                  <div class="form-group">
                    <label for="tk_sefaz" class="col-form-label"
                      >ID Token Sefaz</label
                    >
                    <div class="col">
                      <input
                        v-model="empresa.idtokensefaz"
                        type="text"
                        class="form-control text-left"
                        id="tk_sefaz"
                      />
                    </div>
                  </div>
                </div>
                <div class="col-sm-12 col-md-6">
                  <div class="form-group">
                    <label for="base_icms" class="col-form-label"
                      >Tipo de Ambiente</label
                    >
                    <div class="col">
                      <Multiselect
                        @select="seleciona_ambiente($event)"
                        v-model="select_ambiente"
                        :options="tipos"
                        label="nome"
                      >
                      </Multiselect>
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-row form-group">
                <div class="col-sm-12 col-md-6">
                  <div class="form-group">
                    <label class="col-form-label d-block" for="nfe-ind-sinc"
                      >Enviar NF-e em modo síncrono</label
                    >
                    <b-form-checkbox
                      id="nfe-ind-sinc"
                      v-model="empresa.nfe_ind_sinc"
                      :value="true"
                      :unchecked-value="false"
                    >
                      Enviar NF-e em modo síncrono
                    </b-form-checkbox>
                    <small class="form-text text-muted">
                      Desmarque para usar o envio assíncrono (padrão da SEFAZ). Marque apenas quando a UF exigir envio síncrono.
                    </small>
                  </div>
                </div>
              </div>
              <div class="form-row form-group">
                <div class="col-sm-12 col-md-6">
                  <div class="form-group">
                    <label for="manifesto-ultimo-nsu" class="col-form-label"
                      >Último NSU do Manifesto</label
                    >
                    <div class="col">
                      <input
                        id="manifesto-ultimo-nsu"
                        v-model="empresa.manifesto_ultimo_nsu"
                        type="text"
                        maxlength="15"
                        class="form-control text-left"
                      />
                      <small class="form-text text-muted">
                        Atualizado automaticamente após consultas à SEFAZ. Use para configuração inicial ou recuperação.
                      </small>
                    </div>
                  </div>
                </div>
                <div class="col-sm-12 col-md-6">
                  <div class="form-group">
                    <label for="manifesto-filtro-emitente" class="col-form-label"
                      >Filtro padrão de emitentes</label
                    >
                    <div class="col">
                      <select
                        id="manifesto-filtro-emitente"
                        v-model.number="empresa.manifesto_filtro_emitente"
                        class="form-control"
                      >
                        <option :value="1">Todos os emitentes</option>
                        <option :value="2">Excluir emitentes do mesmo CNPJ base</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-row form-group" role="group">
                <div class="col-sm-12 col-md-12">
                  <div class="form-group">
                    <label for="Reg_trib" class="col-form-label"
                      >Regime tributário (CRT)</label
                    >
                    <div class="col">
                      <Multiselect
                        v-model="select_regime_trib"
                        @select="seleciona_regime_trib($event)"
                        :options="regimes"
                        label="nome"
                      >
                      </Multiselect>
                    </div>
                  </div>
                </div>
              </div>
            </b-card-body>
          </b-collapse>

          <!-- O certificado digital é enviado na tela de edição, após a empresa ser criada -->
        </b-card>
        <!-- engloba  todos-->
      </form>
      <!-- form engloba todos-->
    </div>
    <!--Engloba todos -->
    <div class="card-body">
      <div class="col-md-12 mt-10">
        <button class="btn btn-primary" @click.prevent="setPost()">
          Gravar Empresa
        </button>
      </div>
    </div>
  </div>
</template>